<template>
  <div id="footer" class="content text-white">
    &copy; {{ year }}
    <a target=_blank href="https://mydrills.puzzlefast.com/">mydrills.puzzlefast.com</a>
    &nbsp;&nbsp;|&nbsp;&nbsp;
    <router-link to="/home">About</router-link>
    &nbsp;&nbsp;|&nbsp;&nbsp;
    <router-link to="/terms">Terms of Use</router-link>
    &nbsp;&nbsp;|&nbsp;&nbsp;
    <router-link to="/privacy">Privacy Policy</router-link>
    &nbsp;&nbsp;|&nbsp;&nbsp;
    <router-link to="/contact">Contact</router-link>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    year: function () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
#footer {
  font-size: 0.9rem;
  line-height: 1.6rem;
}
#footer a {
  display: inline-block;
  color: white;
}
#footer a:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/common/Footer.vue